import classnames from "classnames";
import React, { Suspense } from "react";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import LanguageContainer from "./containers/LanguageContainer/LanguageContainer";
import ScreenSaverContainer from "./containers/ScreenSaver/ScreenSaverContainer";
import StartScreenContainer from "./containers/StartScreen/StartScreenContainer";
import StatusBarContainer from "./containers/StatusBar/StatusBarContainer";
import TopControlButtonContainer from "./containers/TopControlButton/TopControlContainer";
import { CashOutScreen } from "./pages/Cashout/CashOutScreen";
import { ChangePinScreen } from "./pages/ChangePin/ChangePinScreen";
import { EnterPinScreen } from "./pages/EnterPin/EnterPinScreen";
import { LimitsAndClosureScreen } from "./pages/LimitsAndClosure/LimistsAndClosureScreen";
import { PitchAnimationScreen } from "./pages/PitchAnimation/PitchAnimationScreen";
import { createI18nextContext } from "./services/i18n";
import JavaNavigationHandler from "./services/Navigation/JavaNavigationHandler";
import {
    navigate,
    navigateToLegacy
} from "./services/Navigation/navigateTo.hoc";

const style = require("./App.scss"); // tslint:disable-line no-var-requires

const i18n = createI18nextContext();

const rethinkIdle = () => null;

const MachineApp = () => {
    return (
        <div className={classnames(style.app)}>
            <TopControlButtonContainer />
            <LanguageContainer />
            <Switch>
                <Route
                    path="/recommendations"
                    component={navigateToLegacy("RECOMMENDATIONS")}
                />
                <Route path="/edd" component={navigateToLegacy("EDD")} />
                <Route path="/bets" component={navigateToLegacy("BETS")} />
                <Route
                    path="/results"
                    component={navigateToLegacy("RESULTS")}
                />
                <Route path="/live" component={navigateToLegacy("LIVE")} />
                <Route
                    path="/manual-payout"
                    component={navigateToLegacy("MANUAL_PAYOUT")}
                />
                <Route
                    path="/account"
                    component={navigateToLegacy("ACCOUNT")}
                />
                <Route
                    path="/account-overview"
                    component={navigateToLegacy("ACCOUNT_OVERVIEW")}
                />
                <Route path="/info" component={navigateToLegacy("INFO")} />
                <Route
                    path="/enter-pin"
                    component={navigate(EnterPinScreen, "ENTER_PIN")}
                />
                <Route
                    path="/change-pin"
                    component={navigate(ChangePinScreen, "CHANGE_PIN")}
                />
                <Route
                    path="/cash-out"
                    component={navigate(CashOutScreen, "CASHOUT")}
                />
                <Route
                    path="/limits-and-closure"
                    // prettier-ignore
                    component={navigate(LimitsAndClosureScreen, "LIMITS_AND_CLOSURE")}
                />
                <Route path="/rethink-idle" component={rethinkIdle} />
                <Route path="/screen-saver" component={ScreenSaverContainer} />
                <Route
                    path="/"
                    component={navigate(StartScreenContainer, "START")}
                />
                <Route path="/" component={StartScreenContainer} />
            </Switch>
            <StatusBarContainer />
        </div>
    );
};

const App = () => (
    <Wrappers>
        <JavaNavigationHandler>
            <Switch>
                <Route
                    path="/pitch-animation"
                    component={PitchAnimationScreen}
                />
                <Route component={MachineApp} />
            </Switch>
        </JavaNavigationHandler>
    </Wrappers>
);

function Wrappers(props: { children: React.ReactNode }) {
    return (
        <BrowserRouter>
            <Suspense fallback={<div />}>
                <I18nextProvider i18n={i18n}>{props.children}</I18nextProvider>
            </Suspense>
        </BrowserRouter>
    );
}

export default App;
